import { Card, CardContent } from "@/components/ui/card";

export default function EmptyContractsState() {
  return (
    <Card>
      <CardContent className="p-8 text-center py-16">
        <p className="text-primary-600 dark:text-primary-400">
          Nenhum contrato encontrado
        </p>
      </CardContent>
    </Card>
  );
}
